<template>
  <path
    class="bottom"
    d="M11 18.8685C11 18.0698 11.8901 17.5934 12.5547 18.0365L19.4453 22.6302C19.7812 22.8541 20.2188 22.8541 20.5547 22.6302L27.4453 18.0365C28.1099 17.5934 29 18.0698 29 18.8685V28C29 28.5523 28.5523 29 28 29H12C11.4477 29 11 28.5523 11 28V18.8685Z"
    fill="currentColor"
  />
  <path
    class="top"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 11C13.4477 11 13 11.4477 13 12V16.7969C13 17.1312 13.1671 17.4434 13.4452 17.6288L19.4452 21.63C19.7811 21.854 20.2189 21.854 20.5548 21.63L26.5548 17.6288C26.8329 17.4434 27 17.1312 27 16.7969V12C27 11.4477 26.5523 11 26 11H14ZM20 13C20.2761 13 20.5 13.2239 20.5 13.5V14H21.5C21.7761 14 22 14.2239 22 14.5C22 14.7761 21.7761 15 21.5 15H20H19.5C19.2239 15 19 15.2239 19 15.5C19 15.7761 19.2239 16 19.5 16H20H20.5C21.3284 16 22 16.6716 22 17.5C22 18.3284 21.3284 19 20.5 19V19.5C20.5 19.7761 20.2761 20 20 20C19.7239 20 19.5 19.7761 19.5 19.5V19L18.5 19C18.2239 19 18 18.7761 18 18.5C18 18.2239 18.2239 18 18.5 18L20 18H20.5C20.7761 18 21 17.7761 21 17.5C21 17.2239 20.7761 17 20.5 17H20H19.5C18.6716 17 18 16.3284 18 15.5C18 14.6716 18.6716 14 19.5 14V13.5C19.5 13.2239 19.7239 13 20 13Z"
    fill="currentColor"
  />
</template>
